import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { AnimalMovementParams, AnimalMovementService } from 'src/services/api/animal-movement.service'

const animalMovementService = new AnimalMovementService()

export function useCreateAnimalMovimentation() {
  const { userFarm: farmId, username } = useAuth()

  return useMutation({
    mutationKey: ['createAnimalMovimentation'],
    mutationFn: (movimentationParams: AnimalMovementParams) =>
      animalMovementService.createTransferMovement({
        ...movimentationParams,
        farmId: farmId!,
        animalId: movimentationParams.idAnimal,
        animalName: movimentationParams.nome,
        loteOrigem: movimentationParams.loteOrigem,
        username
      }),

    onError: () => {
      toast.error('Erro ao criar movimentação do animal')
    }
  })
}
